function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__product-wrap", cart__html);
      $(".cart-drawer__product-wrap").replaceWith(render__html);

      var render__html = $(".cart-drawer__top-text em", cart__html);
      $(".cart-drawer__top-text em").replaceWith(render__html);

      var render__html = $(".cart-drawer__checkout-right h5", cart__html);
      $(".cart-drawer__checkout-right h5").replaceWith(render__html);


    });

  //   // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart em", cart__html);
      $(".header__cart em").replaceWith(render__html);

    });
  // menu drawer 
  fetch("?section_id=menu-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".menu__header-cart em", cart__html);
      $(".menu__header-cart em").replaceWith(render__html);

    });

}




$(".add-to-cart-btn").on("click", function (event) {
  event.preventDefault();
  var variantId = $(this).attr('data-product-id');

  var data = {
    id: variantId,
    quantity: 1
  };


  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      sectionRedering();
      $("body").addClass("cart-open");
      setTimeout(function () {
        $(".cart-drawer__left").addClass('fade-in');
      }, 600);
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    }
  });
})







// increment quantity in cart drawer
function increment_cart(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);
  

}
// decrement quantity in cart drawer
function decrement_cart(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {
  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}

// increment quantity in product

function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;

}
// decrement quantity in product page 
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;

  }
}







$(".single-product-btn-add").on("click", function (e) {
  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      $("body").addClass("cart-open");
      sectionRedering();
      
    },
    error: function (err) {
      console.log(err);
    },
  });
})

